import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';

import translationEN from './assets/locales/en/translation.json';
import translationFR from './assets/locales/fr/translation.json';
import availabilityEN from './assets/locales/en/availability.json';
import availabilityFR from './assets/locales/fr/availability.json';
import homeEN from './assets/locales/en/home.json';
import homeFR from './assets/locales/fr/home.json';
import userProfileEN from './assets/locales/en/userProfile.json';
import positionsEN from './assets/locales/en/positions.json';
import scheduleEN from './assets/locales/en/schedule.json';
import locationEN from './assets/locales/en/location.json';
import bookingEN from './assets/locales/en/booking.json';
import settingEN from './assets/locales/en/settings.json';
import callsheetEN from './assets/locales/en/callsheet.json';
import carryoverEN from './assets/locales/en/carryover.json';
import countryEN from './assets/locales/en/countryNames.json';
import countryFR from './assets/locales/fr/countryNames.json';
import specialProjectEN from './assets/locales/en/specialProject.json';
import dashboardEN from './assets/locales/en/dashboard.json';
import authorizationEN from './assets/locales/en/authorization.json';
import loginErrorEN from './assets/locales/en/loginError.json';
import productListingEN from './assets/locales/en/productListing.json';
import reportingEN from './assets/locales/en/reporting.json';
import closetEN from './assets/locales/en/closet.json';
import agentsEN from './assets/locales/en/agents.json';

// the translations
const resources = {
  en: {
    general: translationEN,
    authorization: authorizationEN,
    availability: availabilityEN,
    home: homeEN,
    userProfile: userProfileEN,
    positions: positionsEN,
    location: locationEN,
    booking: bookingEN,
    setting: settingEN,
    country: countryEN,
    schedule: scheduleEN,
    specialProject: specialProjectEN,
    callsheet: callsheetEN,
    carryover: carryoverEN,
    dashboard: dashboardEN,
    loginError: loginErrorEN,
    productListing: productListingEN,
    reporting: reportingEN,
    closet: closetEN,
    agents: agentsEN
  },
  fr: {
    general: translationFR,
    availability: availabilityFR,
    home: homeFR,
    country: countryFR
  }
};

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    fallbackLng: 'en',
    escapeInterpolation: true,
    defaultNS: 'general',
    resources,
    keySeparator: false // we do not use keys in form messages.welcome
  });

export default i18n;
